import React from 'react';
import {useRouter} from "next/router";
import Overlay from "src/components/Overlay/Overlay";
import Image from "next/image";
import DefaultHeaderImage from "public/assets/other_pages_hero.jpeg";
import HeaderImageAbout from "public/assets/other_pages_hero_1.jpeg";
import HeaderImagePartners from "public/assets/other_pages_hero_2.jpeg";
import GeneralHeaderData from "./locales/data"

const GeneralHeader = () => {
  const { locale, pathname } = useRouter();

  const images = {
    '/our_partners': HeaderImagePartners,
    '/about_company': HeaderImageAbout,
    '/services': DefaultHeaderImage,
  }
  return (
    <section className="relative text-white h-72">
      <Image
        src={images[pathname] ?? DefaultHeaderImage}
        alt=""
        layout="fill"
        className="object-cover"
        priority
        placeholder="blur"
      />
      <Overlay opacity='bg-opacity-60' />
      <div className="container mx-auto absolute px-4 lg:px-0 top-2/4 left-2/4 transform -translate-x-2/4 -translate-y-2/4">
        <h1 className="text-center pt-10">
          <span className="block text-sm minmax-s:text-base md:text-3xl mb-2 font-light tracking-wider">
            {GeneralHeaderData[locale].content_2}
          </span>
          <span className="block text-xl minmax-s:text-2xl md:text-5xl font-medium">
            {GeneralHeaderData[locale].content_1}
          </span>
        </h1>
      </div>
    </section>
  );
};

export default GeneralHeader;